function saveActualStimOrder(){
    if(columnForTrial('stimOptions', window.trialRow).includes('random')){
        var stimOrder = [];

        //audio or video
        if(listStimType[trialRow]== 3 || listStimType[trialRow]== 4){
            var stimType = listStimType[trialRow] == 3 ? "sound" : "video";
            for(var i = 0; i < window.mediaStimOrder.length; i++){
                stimOrder[i] = stimType + window.mediaStimOrder[i];
            }
        }
        else{
            for(var i = 0; i < window.stimOrderRandomized.length; i++){
                stimOrder[i] = window.stimOrderRandomized[i].id;
            }
        }

        window.stimOrder_actual.push(stimOrder.join(';'));
    }
    else{
        window.stimOrder_actual.push("na");
    }
}

function shouldRandomizeStimOrder(trialRow){
    var stimOptions = window.columnForTrial('stimOptions', trialRow);
    return stimOptions && stimOptions.includes('random');
}

function randomizeStimOrder(stimContainers){
    window.stimOrderRandomized = [];

    var stimCount = window.listNoStim[window.trialRow];

    if(window.listTrialScreensTimings[window.trialRow].length>1){
        stimCount = 0;
        for(var i = 0; i < window.listTrialScreensTimings[window.trialRow].length; i++){
            stimCount += window.listTrialScreensTimings[trialRow][i].stimuliNumber;
        }
    }

    var correctStimBeforeRandom;
    const key = window.columnForTrial('key', window.trialRow);
    if(window.isStimKey(key)){
        var correctStimIndex = window.getStimKeyIndex(key);
        // at index 0 it is the target, so we get a value > 0 for stimuli
        correctStimBeforeRandom = stimContainers[correctStimIndex];
    }

    for(var i = 1; i <= stimCount; i++){
        window.stimOrderRandomized[i-1] = stimContainers[i];
        window.stimKeyDict[i] = stimContainers[i];
    }
    shuffle(window.stimOrderRandomized);
    for(var i = 1; i <= stimCount; i++){
        if(correctStimBeforeRandom && window.stimOrderRandomized[i-1] == correctStimBeforeRandom){
            window.correctStim = i;
        }

        for(var stimKeyDictIndex = 1; stimKeyDictIndex <= stimCount; stimKeyDictIndex++) {
            if(stimOrderRandomized[i-1].id === stimKeyDict[stimKeyDictIndex].id) {
                stimKeyDict[stimKeyDictIndex] = i;
            }
        }

        stimContainers[i] = window.stimOrderRandomized[i-1];

	    if (window.isClickTrial()) {
            $(stimContainers[i]).off('click');
            $(stimContainers[i]).on('click', (function(il) {
                return function(e) {
                    clickStim(e, this, il);
                };
            })(i));
        }
    }
}

function cleanRandomizedStimClick() {
    if ( shouldRandomizeStimOrder(window.trialRow) && window.isClickTrial() ){
        var stimCount = window.listNoStim[window.trialRow];

        for(var i = 1; i <= stimCount; i++) {
            $(stimContainers[i]).off('click');
            $(stimContainers[i]).on('click', (function(il) {
                return function(e) {
                    clickStim(e, this, il);
                };
            })(i));
        }
    }
}

function parseStimCssOptions(trialRow) {
    let output = [];
    const sitmOptions = columnForTrial('stimOptions', trialRow);
    //found a css options block
    const cssStart = sitmOptions.indexOf('{');
    const cssEnd = sitmOptions.lastIndexOf('}');
    if (cssStart >= 0 && cssEnd >= 0) {
        const cssString = sitmOptions.substring(cssStart, cssEnd+1);
        const cssOptions = cssString.split('}')
        for (let option of cssOptions) {
            //parse css for current stim
            const cssOptions = {};
            option = option.replace(/[{|}]/g, '').trim();
            let newOption = "";
            for(i = 0; i < option.length; i++) {
                if (option[i] == ";") {
                    newOption = option.slice(0, i) + option.slice(i+1);
                }

                if (option[i] != " ") {
                    break;
                }
            }
            if(newOption.length > 0) {
                option = newOption;
            }
            const currentStimOptions = option.split(';');
            for (let currentCssOption of currentStimOptions) {
                if(currentCssOption.indexOf(':') < 0) {
                    continue;
                }
                let [property,cssValue] = currentCssOption.split(':')
                property = property.trim();
                cssValue = cssValue.trim();
                cssOptions[property] = cssValue;
            }
            output.push(cssOptions);
        }            
    }

    return output;
}

function applyStimCssOption(trialRow, stimIndex) {
    if (listTrialCssOptions[trialRow] && listTrialCssOptions[trialRow][stimIndex - 1]) {
        for (const key in listTrialCssOptions[trialRow][stimIndex - 1]) {
            stimContainers[stimIndex].style[key] = listTrialCssOptions[trialRow][stimIndex - 1][key];
        }
    }
}

function resetStimCssOptions() {
    for(var i = 1; i <= window.stimFieldsMax; i++){
        if (stimContainers[i] && listTrialCssOptions[trialRow] && listTrialCssOptions[trialRow][i - 1]) {
            const currentImageId = `image${i}`; 
            const currentWordId = `word${i}`;
            const imageElement = document.getElementById(currentImageId);
            const wordElement = document.getElementById(currentWordId);
            for (const key in listTrialCssOptions[trialRow][i - 1]) {
                imageElement.style.removeProperty(key);
                wordElement.style.removeProperty(key);
            }
        }
    }
}